export const getSegments = (state) => state.segments;
